/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/**
 * Common types shared across multiple API modules
 * This file is auto-generated to avoid duplicate type definitions
 */
export var PermitValueFrom;
(function (PermitValueFrom) {
    PermitValueFrom[PermitValueFrom["ValueFromStatic"] = 1] = "ValueFromStatic";
    PermitValueFrom[PermitValueFrom["ValueFromRelation"] = 2] = "ValueFromRelation";
    /** 新增：计算表达式 */
    PermitValueFrom[PermitValueFrom["ValueFromFormula"] = 3] = "ValueFromFormula";
})(PermitValueFrom || (PermitValueFrom = {}));
export var PermitEntityProp;
(function (PermitEntityProp) {
    PermitEntityProp["PropCreateTime"] = "created";
    PermitEntityProp["PropUpdateTime"] = "updated";
    PermitEntityProp["PropCreateBy"] = "creator";
})(PermitEntityProp || (PermitEntityProp = {}));
export var PronounsType;
(function (PronounsType) {
    PronounsType[PronounsType["PronounsTypeUnknown"] = 0] = "PronounsTypeUnknown";
    PronounsType[PronounsType["PronounsTypeHeHim"] = 1] = "PronounsTypeHeHim";
    PronounsType[PronounsType["PronounsTypeSheHer"] = 2] = "PronounsTypeSheHer";
    PronounsType[PronounsType["PronounsTypeTheyThem"] = 3] = "PronounsTypeTheyThem";
    PronounsType[PronounsType["PronounsTypeOther"] = 4] = "PronounsTypeOther";
})(PronounsType || (PronounsType = {}));
export var PermitEntityEvent;
(function (PermitEntityEvent) {
    PermitEntityEvent[PermitEntityEvent["EntityCreated"] = 1] = "EntityCreated";
    PermitEntityEvent[PermitEntityEvent["EntityUpdated"] = 2] = "EntityUpdated";
    PermitEntityEvent[PermitEntityEvent["EntityDeleted"] = 3] = "EntityDeleted";
    PermitEntityEvent[PermitEntityEvent["EntitySchemaChanged"] = 4] = "EntitySchemaChanged";
    PermitEntityEvent[PermitEntityEvent["EntityCommentAdded"] = 99] = "EntityCommentAdded";
    PermitEntityEvent[PermitEntityEvent["EntityFlowChanged"] = 11] = "EntityFlowChanged";
    PermitEntityEvent[PermitEntityEvent["EntityFlowAction"] = 12] = "EntityFlowAction";
})(PermitEntityEvent || (PermitEntityEvent = {}));
export var DeveloperClientType;
(function (DeveloperClientType) {
    /** 租户级客户端 */
    DeveloperClientType[DeveloperClientType["ClientTypeTenant"] = 1] = "ClientTypeTenant";
})(DeveloperClientType || (DeveloperClientType = {}));
export var DeveloperClientStatus;
(function (DeveloperClientStatus) {
    DeveloperClientStatus[DeveloperClientStatus["ClientStatusActive"] = 1] = "ClientStatusActive";
    DeveloperClientStatus[DeveloperClientStatus["ClientStatusSuspended"] = 2] = "ClientStatusSuspended";
})(DeveloperClientStatus || (DeveloperClientStatus = {}));
export var NotificationPayloadMode;
(function (NotificationPayloadMode) {
    NotificationPayloadMode[NotificationPayloadMode["PayloadModeJson"] = 0] = "PayloadModeJson";
    NotificationPayloadMode[NotificationPayloadMode["PayloadModeURLEncoded"] = 1] = "PayloadModeURLEncoded";
})(NotificationPayloadMode || (NotificationPayloadMode = {}));
export var NotificationNotificationType;
(function (NotificationNotificationType) {
    NotificationNotificationType["NotificationTypeWebhook"] = "webhook";
    NotificationNotificationType["NotificationTypeSQS"] = "sqs";
})(NotificationNotificationType || (NotificationNotificationType = {}));
export var MagicStringPartType;
(function (MagicStringPartType) {
    MagicStringPartType[MagicStringPartType["MagicStringPartStatic"] = 1] = "MagicStringPartStatic";
    MagicStringPartType[MagicStringPartType["MagicStringPartField"] = 2] = "MagicStringPartField";
    MagicStringPartType[MagicStringPartType["MagicStringPartProp"] = 3] = "MagicStringPartProp";
})(MagicStringPartType || (MagicStringPartType = {}));
export var WorkflowStateType;
(function (WorkflowStateType) {
    WorkflowStateType[WorkflowStateType["Normal"] = 0] = "Normal";
    WorkflowStateType[WorkflowStateType["Processing"] = 1] = "Processing";
    WorkflowStateType[WorkflowStateType["Completed"] = 2] = "Completed";
    WorkflowStateType[WorkflowStateType["Denied"] = 3] = "Denied";
    WorkflowStateType[WorkflowStateType["Cancelled"] = 4] = "Cancelled";
    WorkflowStateType[WorkflowStateType["NotRequired"] = 5] = "NotRequired";
})(WorkflowStateType || (WorkflowStateType = {}));
export var WidgetsTypeCode;
(function (WidgetsTypeCode) {
    WidgetsTypeCode[WidgetsTypeCode["WidgetsTypeDashboard"] = 1] = "WidgetsTypeDashboard";
    WidgetsTypeCode[WidgetsTypeCode["WidgetsTypeIngress"] = 2] = "WidgetsTypeIngress";
})(WidgetsTypeCode || (WidgetsTypeCode = {}));
export var CubeMeasureAggregate;
(function (CubeMeasureAggregate) {
    CubeMeasureAggregate["CubeMeasureAggregateSum"] = "sum";
    CubeMeasureAggregate["CubeMeasureAggregateAvg"] = "avg";
    CubeMeasureAggregate["CubeMeasureAggregateMax"] = "max";
    CubeMeasureAggregate["CubeMeasureAggregateMin"] = "min";
    CubeMeasureAggregate["CubeMeasureAggregateCount"] = "count";
    CubeMeasureAggregate["CubeMeasureAggregateDistinctCount"] = "distinct_count";
})(CubeMeasureAggregate || (CubeMeasureAggregate = {}));
